import React from 'react';
import Testimonial from '../../components/testimonial/Testimonial';
import WhyChooseUs from '../../components/whychooseus/WhyChooseUs';
import Breadcrumb from '../common/Breadcrumb';
import Footer from '../common/Footer';
import Header from '../common/Header';
import { Helmet } from 'react-helmet';

function NadIVDripTherapy() {
  return (
    <div>
      <Helmet>
        <title>NAD Drip Therapy in Gurgaon | Swakaaya Aesthetics</title>
        <meta
          name='description'
          content='Boost energy and wellness with NAD drip therapy in Gurgaon at Swakaaya. Advanced IV therapy for revitalization.'
        />
        <meta
          name='keywords'
          content='NAD drip therapy Gurgaon, IV therapy Gurgaon, energy boost Gurgaon'
        />
        <link
          rel='canonical'
          href='https://swakaaya.com/our-services/nad-drip-therapy'
        />

        <meta
          property='og:title'
          content='NAD Drip Therapy in Gurgaon | Swakaaya Aesthetics'
        />
        <meta
          property='og:description'
          content='Boost energy and wellness with NAD drip therapy in Gurgaon at Swakaaya. Advanced IV therapy for revitalization.'
        />
        <meta
          property='og:url'
          content='https://swakaaya.com/our-services/nad-drip-therapy'
        />
        <meta property='og:type' content='website' />
        <meta
          property='og:image'
          content='https://swakaaya.com/assets/images/logo.png'
        />

        <meta name='twitter:card' content='summary_large_image' />
        <meta
          name='twitter:title'
          content='NAD Drip Therapy in Gurgaon | Swakaaya Aesthetics'
        />
        <meta
          name='twitter:description'
          content='Boost energy and wellness with NAD drip therapy in Gurgaon at Swakaaya. Advanced IV therapy for revitalization.'
        />
        <meta
          name='twitter:image'
          content='https://swakaaya.com/assets/images/logo.png'
        />
      </Helmet>
      <Header />
      <Breadcrumb title={'NAD IV Drip Therapy'} />
      <section className='section section-padding-02 '>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='service-content'>
                <div>
                  <div>
                    <h2>
                      <strong>NAD IV DRIP THERAPY</strong>
                    </h2>

                    <div>
                      <p>
                        NAD IV Drip Therapy is a wellness treatment that helps
                        boost your energy, improve focus, and slow down early
                        signs of aging. NAD is a natural substance already
                        present in our body that keeps our cells active and
                        healthy. Over time, stress and age lower its levels,
                        making us feel tired and less energetic.
                      </p>
                      <p>
                        This therapy gently restores NAD by giving it directly
                        into the bloodstream. The result is better energy, a
                        clear mind, and an overall refreshed feeling from
                        within.
                      </p>

                      <p>
                        <strong>THE NAD IV DRIP PROCEDURE INCLUDES:</strong>
                      </p>
                      <ul>
                        <li>A short consultation to understand your needs</li>
                        <li>
                          A small IV line is set by a trained professional
                        </li>
                        <li>
                          The NAD drip is given slowly while you relax
                          comfortably
                        </li>
                        <li>The session usually takes 1.5 to 3 hours</li>
                        <li>
                          You can get back to normal activities right after
                        </li>
                      </ul>

                      <p>
                        <strong>HOW LONG DOES IT TAKE TO SHOW RESULTS?</strong>
                      </p>
                      <p>
                        Many people feel fresh, focused, and energetic soon
                        after their first session. With regular sessions,
                        benefits like better sleep, improved mood, and
                        long-lasting energy become more noticeable.
                      </p>

                      <p>
                        <strong>
                          WHAT ARE THE BENEFITS OF NAD IV DRIP THERAPY?
                        </strong>
                      </p>
                      <ul>
                        <li>Increases natural energy levels</li>
                        <li>Improves focus and mental clarity</li>
                        <li>Supports healthy aging and cell repair</li>
                        <li>Reduces tiredness and helps in faster recovery</li>
                        <li>Helps in managing stress and uplifting mood</li>
                        <li>Promotes overall health and wellness</li>
                      </ul>
                      <p>
                        NAD IV Drip Therapy is safe, comfortable, and done under
                        professional care, making it a trusted choice for anyone
                        looking to recharge their body and mind.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <WhyChooseUs />
      <Testimonial />
      <Footer />
    </div>
  );
}

export default NadIVDripTherapy;
